import { PageId } from '~/shared/constants'

export const getPageIdFromPathName = (pathName: string) =>
  pathName.replace(/\//, '') as PageId
